import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-email",
  "use": "icon-email-usage",
  "viewBox": "0 0 90 58",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 90 58\" id=\"icon-email\"><path d=\"M4 1C2.373 1 1 2.373 1 4v50c0 1.627 1.373 3 3 3h82c1.627 0 3-1.373 3-3V4c0-1.627-1.373-3-3-3H4Zm4.188 4h73.624L45 37.344 8.187 5ZM5 7.531l24.219 21.25L5 50.406V7.531Zm80 0v42.875L60.781 28.781 85 7.531ZM32.25 31.438 43.688 41.5a2 2 0 0 0 2.624 0L57.75 31.438 81.906 53H8.094L32.25 31.438Z\" fill=\"#172B0E\" stroke=\"#172B0E\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol